import { first } from "rxjs/operators";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "@app/_services";
import {
  LazyLoadEvent,
  MessageService,
  ConfirmationService,
} from "primeng/api";
import { MsgTemplate } from "../msg-template";
import { MsgTemplateService } from "../msg-template.service";
import { MsgTemplateComponent } from "../msg-template/msg-template.component";
import { MsgService } from "@app/_components/msg";
import * as ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import * as moment from "moment";

@Component({
    selector: "app-msg-template-list",
    templateUrl: "./msg-template-list.component.html",
    styleUrls: ["./msg-template-list.component.css"],
    providers: [
        MessageService,
        ConfirmationService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    // make column heading sticky
    styles: [
        `
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
      }

      @media screen and (max-width: 64em) {
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
        }
      }
    `,
    ],
    standalone: false
})
export class MsgTemplateListComponent implements OnInit {
  constructor(
    private msgTemplateService: MsgTemplateService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private msgService: MsgService,
    private dialog: MatDialog
  ) {
    this.statuses = msgTemplateService.statuses;
    this.statusesForFilter.push.apply(this.statusesForFilter, this.statuses);
    this.msgAudiences = msgService.msgAudiences;
  }
  msgAudiences: any;
  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  msgTemplates: any;
  msgTemplate: MsgTemplate;

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;
  statusesForFilter = [{ value: null, name: 'All' }];
  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  statuses: any;

  globalSearchValue: string = '';

  exportToExcelLoading = false;

  columns: any[] = [
    { field: 'msgTemplateId', header: 'Msg TemplateId', width: 'auto' },
    { field: 'letterHeadTemplate.msgTemplateId', header: 'LetterHeadId', width: 'auto' },
    { field: 'name', header: 'Name', width: '350px' },
    { field: 'status', header: 'Status/Type', width: '100px' },
    { field: 'msgAudience', header: 'Audience', width: '100px' },
    { field: 'subject', header: 'Subject', width: '800px' },
    // { field: 'emailHtml', header: 'Email HTML', width: 'auto' },
    // { field: 'emailText', header: 'Email Text', width: 'auto' },
    // { field: 'mobileText', header: 'Mobile Text', width: 'auto' },
    // { field: 'senderName', header: 'Sender Name', width: 'auto' },
    { field: 'senderEmail', header: 'Sender Email', width: 'auto' },
    { field: 'senderMobileNum', header: 'Sender Mobile Number', width: 'auto' },
    { field: 'senderCountryCode', header: 'Sender Country Code', width: '10px' }
  ];

  ngOnInit(): void {
    try {
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: "createDate", order: 0 });
    } catch (error) {
      console.log("Error: " + error);
    }
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + event.msgTemplateId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        " event.first:" +
          event.first +
          "  |  event.rows:" +
          event.rows +
          "  |  event.sortField:" +
          event.sortField +
          "  |  event.sortOrder:" +
          event.sortOrder +
          "  |  event.multiSortMeta:" +
          JSON.stringify(event.multiSortMeta) +
          "  |  event.globalFilter:" +
          event.globalFilter +
          "  |  event.filters:" +
          JSON.stringify(event.filters)
      );

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-msgTemplate-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      if(this.globalSearchValue)
			{
				// show only proformas that are assigned to this realtorProfileId
				let globalSearchFilter = { 'globalFilter': { 'value': this.globalSearchValue, 'matchMode': 'in' } };
				Object.assign(event.filters, globalSearchFilter);
			}
      // If there is no globalFilter, remove it from event.filters
      if (!this.globalSearchValue && event.filters['globalFilter']) {
        delete event.filters['globalFilter'];  // Removing globalFilter from the event filters
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.msgTemplateService
        .findByFilter(
          pageNumber,
          event.rows,
          event.sortField,
          event.sortOrder,
          event.multiSortMeta,
          event.globalFilter,
          event.filters
        )
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.datasource = res.data.reviews;
            this.recordTotal = res.page.recordTotal;
            this.msgTemplates = res.data.msgTemplates;
            console.log(JSON.stringify(res.page));
          },
          (err: any) => {
            console.log("reviews list error!: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.loading = false;
          }
        );

      if (this.datasource) {
        this.msgTemplates = this.datasource.slice(
          event.first,
          event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  onGlobalSearch(event: any) {
    this.loadLazy(this.lazyLoadEvent);
  }

    // This method will be triggered on input change (to check if the value is empty)
    onInputChange() {
      // If the value is empty and was not previously empty, call loadLazy
      if (this.globalSearchValue.trim() === '') {
        this.loadLazy(this.lazyLoadEvent);
      }
    }


  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log("onRowSelect: " + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() {}

  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(msgTemplate: MsgTemplate) {
    try {
      this.formLoading = true;
      this.msgTemplateService.update(msgTemplate).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Update SUCCESS: " + JSON.stringify(res));
          this.msgTemplates.map((msgTemplate, i) => {
            if (
              msgTemplate.msgTemplateId === res.data.msgTemplate.msgTemplateId
            ) {
              this.msgTemplates[i] = res.data.msgTemplate;
            }
          });
          // this.alertService.success(res, true);
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Update FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: JSON.stringify(err),
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(msgTemplate: any) {
    try {
      // stop here if form is invalid
      console.log("Delete Submitted: " + JSON.stringify(msgTemplate));

      this.formLoading = true;
      this.msgTemplateService.delete(msgTemplate.msgTemplateId).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Delete SUCCESS: " + JSON.stringify(res));
          this.msgTemplates.splice(this.msgTemplates.indexOf(msgTemplate), 1);
          this.recordTotal = this.msgTemplates.length;
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "MsgTemplate " + msgTemplate.msgTemplateId + " Deleted",
            life: 3000,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Delete  FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: "Delete Failed",
            detail:
              "MsgTemplate " +
              msgTemplate.msgTemplateId +
              " could not be deleted.  Be sure there are no assigned properties to this bucket.",
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add MsgTemplate",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgTemplateComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addMsgTemplateCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(msgTemplate: MsgTemplate) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      msgTemplate: msgTemplate,
      title: "Edit MsgTemplate",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgTemplateComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.updateMsgTemplateCB(data);

      // close the dialogBox
      dialogRef.close();
    });

    dialogRef.componentInstance.doDelete.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.deleteMsgTemplateCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addMsgTemplateCB(msgTemplate: MsgTemplate) {
    console.log("Adding MsgTemplate: " + JSON.stringify(msgTemplate));
    // if we don't have a msgTemplates array yet...
    if (!this.msgTemplates) {
      this.msgTemplates = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.msgTemplates.unshift(msgTemplate);

    // no idea what this is but it is required to update the array
    this.msgTemplates = [...this.msgTemplates];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgTemplate " + msgTemplate.msgTemplateId + " Added",
      life: 3000,
    });
  }

  updateMsgTemplateCB(msgTemplate: MsgTemplate) {
    console.log("Updating MsgTemplate: " + JSON.stringify(msgTemplate));
    let itemIndex = this.msgTemplates.findIndex(
      (item: any) => item.msgTemplateId === msgTemplate.msgTemplateId
    );
    this.msgTemplates[itemIndex] = msgTemplate;

    // no idea what this is but it is required to update the array
    this.msgTemplates = [...this.msgTemplates];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgTemplate " + msgTemplate.msgTemplateId + " Updated",
      life: 3000,
    });
  }

  deleteMsgTemplateCB(msgTemplate: MsgTemplate) {
    console.log("Removing MsgTemplate: " + msgTemplate);
    this.msgTemplates.splice(this.msgTemplates.indexOf(msgTemplate), 1);
    this.recordTotal = this.msgTemplates.length;

    // no idea what this is but it is required to update the array
    this.msgTemplates = [...this.msgTemplates];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgTemplate " + msgTemplate.msgTemplateId + " Deleted",
      life: 3000,
    });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
  }
  prev() {
    this.first = this.first - this.rows;
  }
  reset() {
    this.first = 0;
  }
  isLastPage(): boolean {
    return this.msgTemplates
      ? this.first === this.msgTemplates.length - this.rows
      : true;
  }
  isFirstPage(): boolean {
    return this.msgTemplates ? this.first === 0 : true;
  }

  get Statuses() {
    return this.statuses;
  }

  getStatusName(msgTemplate: any) {
    if (msgTemplate?.status || msgTemplate?.status==0) {
      const status = this.statuses.find(
        (e: any) => e.value == msgTemplate.status
      );
      return status.name;
    } else {
      return '';
    }
  }

  reloadPage() {
    window.location.reload();
  }

  exportToExcel(): void {
    if (this.exportToExcelLoading) {
      return;
    }
    this.exportToExcelLoading = true;
    setTimeout(() => {
      this.runExportToExcel();
    }, 0);
  }

  private runExportToExcel(): void {
    const total = this.recordTotal || 0;
    const rowsToFetch = total > 0 ? Math.min(total, 50000) : 10000;
    const event: LazyLoadEvent = {
      first: 0,
      rows: rowsToFetch,
      filters: this.lazyLoadEvent?.filters ? { ...this.lazyLoadEvent.filters } : {},
      multiSortMeta: this.lazyLoadEvent?.multiSortMeta ? [...(this.lazyLoadEvent.multiSortMeta || [])] : [{ field: 'createDate', order: -1 }],
      sortField: this.lazyLoadEvent?.sortField,
      sortOrder: this.lazyLoadEvent?.sortOrder,
      globalFilter: this.lazyLoadEvent?.globalFilter
    };
    if (!event.multiSortMeta?.length) {
      event.multiSortMeta = [{ field: 'createDate', order: -1 }];
    }
    if (this.globalSearchValue) {
      event.filters = event.filters || {};
      (event.filters as any)['globalFilter'] = { value: this.globalSearchValue, matchMode: 'in' };
    }
    const pageNumber = 0;
    this.msgTemplateService
      .findByFilter(
        pageNumber,
        event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters
      )
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          const list = res?.data?.msgTemplates || [];
          this.buildAndDownloadExcel(list);
          this.messageService.add({
            severity: 'success',
            summary: 'Export Complete',
            detail: `Exported ${list.length} template(s) to Excel`,
            life: 3000
          });
        },
        error: (err) => {
          console.error('Export failed:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Export Failed',
            detail: err?.message || 'Failed to export msg templates',
            life: 5000
          });
        },
        complete: () => {
          this.exportToExcelLoading = false;
        }
      });
  }

  private buildAndDownloadExcel(templates: any[]): void {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Msg Templates', { views: [{ state: 'frozen', ySplit: 1 }] });

    const headers = [
      'Msg Template Id',
      'Name',
      'Status/Type',
      'Audience',
      'Subject',
      'Sender Name',
      'Sender Email',
      'Sender Mobile Number',
      'Sender Country Code',
      'Letter Head Id',
      'Mobile Text',
      'Email Text',
      'Email HTML',
      'Ops Notes',
      'Created',
      'Last Update'
    ];
    const headerRow = sheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.height = 22;
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    templates.forEach((t) => {
      const letterHeadId = t?.letterHeadTemplate?.msgTemplateId ?? t?.letterHeadTemplateId ?? '';
      const emailHtml = t?.emailHtml != null ? String(t.emailHtml).replace(/<[^>]*>/g, ' ').trim() : '';
      const row = [
        t?.msgTemplateId ?? '',
        t?.name ?? '',
        this.getStatusName(t),
        this.getMsgAudienceName(t),
        t?.subject ?? '',
        t?.senderName ?? '',
        t?.senderEmail ?? '',
        t?.senderMobileNum ?? '',
        t?.senderCountryCode ?? '',
        letterHeadId,
        t?.mobileText ?? '',
        t?.emailText ?? '',
        emailHtml,
        t?.opsNotes ?? '',
        t?.createDate ? moment(t.createDate).format('YYYY-MM-DD HH:mm') : '',
        t?.lastUpdate ? moment(t.lastUpdate).format('YYYY-MM-DD HH:mm') : ''
      ];
      sheet.addRow(row);
    });

    sheet.columns.forEach((col) => {
      let max = 10;
      col.eachCell?.({ includeEmpty: true }, (cell) => {
        const len = cell.value != null ? String(cell.value).length : 0;
        if (len > max) max = len;
      });
      col.width = Math.min(max + 1, 80);
    });

    const lastDataRow = 1 + templates.length;
    const lastCol = headers.length;
    const lastColLetter = lastCol <= 26 ? String.fromCharCode(64 + lastCol) : 'A' + String.fromCharCode(64 + lastCol - 26);
    if (lastDataRow > 1) {
      sheet.autoFilter = { from: 'A1', to: `${lastColLetter}${lastDataRow}` };
    }

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const fileName = `Msg_Templates_${moment().format('MM-DD-YYYY_HH-mm-ss')}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    });
  }

  showPaginator() {
    return true;
  }
  getMsgAudienceName(msg: any) {
    if (msg?.msgAudience) {
      const top = this.msgAudiences.find((e: any) => e.value == msg.msgAudience);
      return top?.name;
    } else {
      return '';
    }
  }
}
